import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SharedButton from '../components/Shared/SharedButton';
import BusinessModal from './BusinessModal';
import BusinessTable from './BusinessTable';
import useFetchData from '../hooks/useFetchData';

export default function MainBusiness() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: businessData, loading, executeFetch } = useFetchData();
  const [createDialogVisible, setCreateDialogVisible] = useState(false);

  useEffect(() => {
    executeFetch("POST", "listCompanies", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "listCompanies", { page: newPage, per_page: newRowsPerPage });
  };

  return (
    <>
      <div className='flex justify-end mb-2'>
        <SharedButton
          label={t('CreateCompany')}
          icon='pi pi-plus'
          onClick={() => navigate('/manager/business/create')}
          className='bg-primary primary-btn'
        />
      </div>
      <BusinessTable
        data={businessData}
        loading={loading}
        onPageChange={handlePageChange}
        onRefresh={() => executeFetch("POST", "listCompanies", { page: 1, per_page: 10 })}
      />
      <BusinessModal
        setCreateDialogVisible={setCreateDialogVisible}
        createDialogVisible={createDialogVisible}
        onRefresh={() => executeFetch("POST", "listCompanies", { page: 1, per_page: 10 })}
      />
    </>
  );
}
